import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import { DASHBOARD_MENU, LOCAL_STORAGE_KEYS, PRODUCT_TYPES } from '../shared/utils';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    initCurrentDashboardSource(): BehaviorSubject<DASHBOARD_MENU> {
        const signupProductType = localStorage.getItem(LOCAL_STORAGE_KEYS.SIGNUP_PRODUCT_TYPE) || null;

        const defaultDashboard: DASHBOARD_MENU = signupProductType === PRODUCT_TYPES.DBC ? DASHBOARD_MENU.CARDS : DASHBOARD_MENU.QRCODES;
        // Reset the localStorage once initialized
        if (signupProductType === PRODUCT_TYPES.DBC) {
            localStorage.removeItem(LOCAL_STORAGE_KEYS.SIGNUP_PRODUCT_TYPE);
        }
        return new BehaviorSubject<DASHBOARD_MENU>(defaultDashboard);
    }

    private currentDashboardSource: BehaviorSubject<DASHBOARD_MENU> = this.initCurrentDashboardSource();
    public currentDashboard$: Observable<DASHBOARD_MENU> = this.currentDashboardSource.asObservable();

    constructor() {
    }

    setCurrentDashboard(value: DASHBOARD_MENU) {
        setTimeout(() => {
            this.currentDashboardSource.next(value);
        }, 0);
    }

    get currentDashboardSourceValue() {
        return this.currentDashboardSource.value;
    }
}
